export function Logo({ className = "h-9 w-9" }) {
  return (
    <img
      src="/logo-mark.png?v=2"
      alt="Bhaaskar Productions logo"
      className={`${className} object-contain`}
    />
  );
}

export function Wordmark({ tag = true }) {
  return (
    <div className="flex flex-col leading-none">
      <span className="font-display text-lg font-semibold tracking-[0.18em] text-white">BHAASKAR</span>
      {tag && <span className="text-[9px] tracking-[0.42em] text-white/45 mt-0.5">PRODUCTIONS</span>}
    </div>
  );
}
